export enum PresentationFile {
    PDF = "application/pdf",
}
